import { render, staticRenderFns } from "./PopDetail.vue?vue&type=template&id=6ca3bc99&scoped=true"
import script from "./PopDetail.vue?vue&type=script&lang=js"
export * from "./PopDetail.vue?vue&type=script&lang=js"
import style0 from "./PopDetail.vue?vue&type=style&index=0&id=6ca3bc99&prod&scoped=true&lang=css"
import style1 from "./PopDetail.vue?vue&type=style&index=1&id=6ca3bc99&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca3bc99",
  null
  
)

export default component.exports